import React from 'react';
import DefaultView from 'partial/OfferManager/modules/Default/DefaultView';

class DefaultController extends React.Component {
  render() {
    return (
      <DefaultView
        {...this.props}
        offers={this.props.offers ? this.props.offers : []}
      />
    );
  }
}

export default DefaultController;
